module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.telegram-fce925d4b5382627f1ebddd97d47334b.svg";